import {SalesChannel} from '../consts/sales-channel.enum';
import {ResourceKey} from '../consts/resource-key.enum';
import {EnvironmentConsts} from '../models/environment.consts';

export const RESOURCES_CONFIG: ResourcesConfig = {
    resources: [
        {
            key: ResourceKey.KP_REGULATIONS,
            uriSuffix: 'RESOURCES/PORTAL/KIOSKPOLIS/V1/KP_REGULAMIN.pdf'
        },
        {
            key: ResourceKey.KP_IDD,
            uriSuffix: 'RESOURCES/PARTNERS/KIOSKPOLIS/V1/KP_IDD.pdf'
        },
        {
            key: ResourceKey.KP_PERSONAL_DATA_ADMINISTRATOR_INFO,
            uriSuffix: 'RESOURCES/PARTNERS/KIOSKPOLIS/V1/KP_INFORMACJA_O_ADMINISTRATORZE_DANYCH_OSOBOWYCH.pdf'
        }
    ],
    customResourceEndpoints: [
        {
            salesChannel: SalesChannel.SKYCASH,
            endpoints: [
                {
                    env: EnvironmentConsts.DEV,
                    endpoint: 'https://resources-test-skycash-communication.kioskpolis.pl'
                },
                {
                    env: EnvironmentConsts.TEST,
                    endpoint: 'https://resources-test-skycash-communication.kioskpolis.pl'
                },
                {
                    env: EnvironmentConsts.PROD,
                    endpoint: 'https://resources-skycash-communication.kioskpolis.pl'
                }
            ]
        }
    ]
};

export interface ResourcesConfig {
    resources: ResourceConfig[];
    customResourceEndpoints?: ResourcesEndpointConfig[];
}

export interface ResourceConfig {
    key: ResourceKey;
    uriSuffix: string; // used to build full path to resource which is a concatenation of resourceEndpoint and this value
}

export interface ResourcesEndpointConfig {
    salesChannel: SalesChannel;
    endpoints: EnvironmentEndpoint[];
    // dev: string;
    // test: string;
    // prod: string;
}

export interface EnvironmentEndpoint {
    env: EnvironmentConsts;
    endpoint: string;
}
